import React from "react";
import CallToAction from "../auth/CallToAction";
import { Link } from "react-router-dom";
import "./welcome.css";

function Welcome(props) {
	return (
		<main className="main-welcome">
			{/* GREETINGS MESSAGE */}

			<h3 className="h3-welcome">Welcome</h3>
			<p className="p-welcome">
				Share, organize and{" "}
				<span>
					<Link
						className="welcome-link welcome-link-explore"
						to={`/browse`}
						title="Hello, this is just my page."
					>
						explore
					</Link>
				</span>{" "}
				bookmarks. Nothing is hidden, everything is public.
			</p>

			{/* GREETINGS MESSAGE */}
			<Link
				className="welcome-link"
				to={`/browse/PAnr1Tg1lnXX8vY2k0cMC4k2o2i2`}
				title="Hello, this is just my page."
			>
				Page example
			</Link>

			<CallToAction
				setUser={props.setUser}
				fetchFirebase={props.fetchFirebase}
			/>

			{/* TITLE */}
			<h2 className="h2-welcome">bkz-src</h2>
		</main>
	);
}

export default Welcome;
